import { render, staticRenderFns } from "./InvestmentDetails.vue?vue&type=template&id=1d0fc75c&scoped=true"
import script from "./InvestmentDetails.vue?vue&type=script&lang=js"
export * from "./InvestmentDetails.vue?vue&type=script&lang=js"
import style0 from "./InvestmentDetails.vue?vue&type=style&index=0&id=1d0fc75c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0fc75c",
  null
  
)

export default component.exports